import { render, staticRenderFns } from "./apply1.vue?vue&type=template&id=283cc0fe&scoped=true&"
import script from "./apply1.vue?vue&type=script&lang=js&"
export * from "./apply1.vue?vue&type=script&lang=js&"
import style0 from "./apply1.vue?vue&type=style&index=0&id=283cc0fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283cc0fe",
  null
  
)

export default component.exports